var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBillingCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "#F3F4F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8153 14.0305C12.9071 14.0727 13.0105 14.0823 13.1085 14.0578C13.2065 14.0333 13.2932 13.9762 13.3544 13.8958L13.5122 13.6892C13.595 13.5788 13.7024 13.4892 13.8258 13.4275C13.9492 13.3658 14.0853 13.3336 14.2233 13.3336H15.5566C15.7924 13.3336 16.0185 13.4273 16.1852 13.594C16.3519 13.7607 16.4455 13.9868 16.4455 14.2225V15.5558C16.4455 15.7916 16.3519 16.0177 16.1852 16.1844C16.0185 16.3511 15.7924 16.4447 15.5566 16.4447C13.4349 16.4447 11.4001 15.6019 9.89979 14.1016C8.3995 12.6013 7.55664 10.5665 7.55664 8.44474C7.55664 8.20899 7.65029 7.9829 7.81699 7.8162C7.98369 7.6495 8.20978 7.55585 8.44553 7.55585H9.77886C10.0146 7.55585 10.2407 7.6495 10.4074 7.8162C10.5741 7.9829 10.6678 8.20899 10.6678 8.44474V9.77807C10.6678 9.91606 10.6356 10.0522 10.5739 10.1756C10.5122 10.299 10.4226 10.4064 10.3122 10.4892L10.1042 10.6452C10.0226 10.7075 9.96509 10.7961 9.94144 10.896C9.91778 10.9959 9.92943 11.1009 9.97442 11.1932C10.5818 12.4269 11.5808 13.4246 12.8153 14.0305Z",
    stroke: "#1E2939",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingCall);
export default __webpack_public_path__ + "static/media/billing-call.53e42820908c2d90904f63595e256e9f.svg";
export { ForwardRef as ReactComponent };